// opervex-frontend/src/Opervex/Report/Stock.js

class Stock {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "depositType",
        label: "Código Tipo Depósito",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "depositTypeText",
        label: "Texto Tipo Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "depositId",
        label: "Código Depósito",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "depositDescription",
        label: "Texto Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "productId",
        label: "Código Produto",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "productDescription",
        label: "Descrição Produto",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "controlSerial",
        label: "Controle - Serial",
        type: "boolean",
        visible: true,
        hidden: false,
      },
      {
        key: "controlMac",
        label: "Controle - MAC",
        type: "boolean",
        visible: true,
        hidden: false,
      },
      {
        key: "quantity",
        label: "Quantidade",
        type: "decimal",
        decimals: 3,
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Stock;
